import { createSlice } from "@reduxjs/toolkit";
import { projectCoWorkersList } from "./projectAsyncThunk";
import uniqBy from "lodash-es/uniqBy";

const projectCoWorkersListSlice = createSlice({
  name: "project",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [projectCoWorkersList.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [projectCoWorkersList.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = uniqBy(state.payload.concat(action.payload.list), "id");
    },
    [projectCoWorkersList.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default projectCoWorkersListSlice.reducer;
